import React from 'react'
import cl from 'classnames'

import Spinner from '../Spinner/Spinner'

import { Props } from './types'

import styles from './styles.module.scss'

const FilledCard: React.FC<Props> = ({ children, wrapperClassName, className, isLoading }) => {
	return (
		<div className={cl(styles.cardWrapper, wrapperClassName)}>
			<div className={cl(styles.card, className)}>
				{isLoading ? (
					<div className={styles.holder}>
						<Spinner />
					</div>
				) : (
					children
				)}
			</div>
		</div>
	)
}

export default FilledCard
